module.exports = __webpack_public_path__ + "img/persis-foods-rgb.6b09a86.png";